import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { mathJaxCodes } from '../create-multi-data/mathjax-constants';

@Component({
  selector: 'app-mathjax-editor',
  templateUrl: './mathjax-editor.component.html',
  styleUrls: ['./mathjax-editor.component.scss'],
})
export class MathjaxEditorComponent implements OnInit {
  text: string = '';
  mathjaxCodes = mathJaxCodes;
  @Input() mathjaxTextarea: HTMLTextAreaElement | undefined;
  @Output() updateValue = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  addMathjaxContent(firstString: string, secondString: string): void {
    if (this.mathjaxTextarea) {
      const start = this.mathjaxTextarea.selectionStart;
      const end = this.mathjaxTextarea.selectionEnd;

      // Combine the two strings
      const combinedText = firstString + secondString;

      // Insert the combined text at the cursor position
      // this.text =
      //   this.text.slice(0, start) + combinedText + this.text.slice(end);
      let value = this.mathjaxTextarea.value;
      value = value.slice(0, start) + combinedText + value.slice(end);
      this.updateValue.emit(value);

      // Calculate the new cursor position (middle of the inserted text)
      const newCursorPosition = start + firstString.length;

      // Update the cursor position
      setTimeout(() => {
        if (this.mathjaxTextarea) {
          this.mathjaxTextarea.selectionStart =
            this.mathjaxTextarea.selectionEnd = newCursorPosition;
          this.mathjaxTextarea.focus();
        }
      });
    }
  }
}
